module.exports = __webpack_public_path__ + "img/phone.908e53b8.svg";